import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { FontAwesomeIcon } from "./FontAwesomeIcon";
import "./new-dora-inputs.scss";
const DoraNumberInput = (props) => {
    const { id, icon, placeholder, className, error, register, onChange, disabled, suffix, onPaste, autoFocus, disableUpDownArrows, step, onBlur, min, max, "aria-label": ariaLabel, } = props;
    const wrapperClasses = classnames("dora-text-input-wrapper", disabled ? "dora-text-input-wrapper--disabled" : null, error ? "dora-text-input-wrapper--error" : null, className);
    const classes = classnames("dora-text-input__input", {
        "dora-text-input__input--with-icon": !!icon,
    });
    const onChangeProp = !props.register
        ? {
            onChange: (e) => onChange && onChange(e.target.value),
        }
        : {};
    const handlePaste = (e) => {
        if (onPaste) {
            e.preventDefault();
            const pasted = e.clipboardData.getData("text");
            onPaste(pasted);
        }
    };
    const handleKeyDown = (e) => {
        if (!disableUpDownArrows) {
            return;
        }
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    return (_jsxs("div", { className: wrapperClasses, children: [icon && (_jsx("div", { className: "dora-text-input__icon", children: _jsx(FontAwesomeIcon, { icon: icon }) })), suffix && _jsx("div", { className: "dora-text-input__suffix", children: suffix }), _jsx("input", { type: "number", ...(id && { id }), ...register, ...(step && { step: step.toString() }), ...onChangeProp, ...(autoFocus && { autoFocus: true }), ...(!register && props.value !== undefined && { value: props.value }), ...(min !== undefined && { min }), ...(max !== undefined && { max }), ...(ariaLabel !== undefined && { "aria-label": ariaLabel }), ...(onBlur && { onBlur }), disabled: disabled, className: classes, placeholder: placeholder, onPaste: handlePaste, onKeyDown: handleKeyDown })] }));
};
const UFDoraNumberInput = (props) => {
    const { register, ...rest } = props;
    return _jsx(DoraNumberInput, { register: register, ...rest });
};
export { DoraNumberInput, UFDoraNumberInput };
//# sourceMappingURL=DoraNumberInput.js.map